import { creditCardConstants } from "../_constants";

export const creditCardCashbackDetailsRequest = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_REQUEST,
    payload,
  };
};

export const creditCardCashbackDetailsComplete = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_COMPLETE,
    payload,
  };
};

export const creditCardCashbackDetailsError = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_ERROR,
    payload,
  };
};

export const creditCardTransactionListRequest = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_REQUEST,
    payload,
  };
};

export const creditCardTransactionListComplete = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_COMPLETE,
    payload,
  };
};

export const creditCardTransactionListError = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_ERROR,
    payload,
  };
};

export const creditCardStatementListRequest = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_STATEMENT_LIST_REQUEST,
    payload,
  };
};

export const creditCardStatementListComplete = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_STATEMENT_LIST_COMPLETE,
    payload,
  };
};

export const creditCardStatementListError = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_STATEMENT_LIST_ERROR,
    payload,
  };
};

export const creditCardStatementDetailsRequest = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_REQUEST,
    payload,
  };
};

export const creditCardStatementDetailsComplete = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_COMPLETE,
    payload,
  };
};

export const creditCardStatementDetailsError = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_ERROR,
    payload,
  };
};

export const creditCardSupplementaryDetailsRequest = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_REQUEST,
    payload,
  };
};

export const creditCardSupplementaryDetailsComplete = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_COMPLETE,
    payload,
  };
};

export const creditCardSupplementaryDetailsError = (payload) => {
  return {
    type: creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_ERROR,
    payload,
  };
};

export const debitCardDetailsRequest = (payload) => {
  return {
    type: creditCardConstants.DEBIT_CARD_DETAILS_REQUEST,
    payload,
  };
};

export const debitCardDetailsComplete = (payload) => {
  return {
    type: creditCardConstants.DEBIT_CARD_DETAILS_COMPLETE,
    payload,
  };
};

export const debitCardDetailsError = (payload) => {
  return {
    type: creditCardConstants.DEBIT_CARD_DETAILS_ERROR,
    payload,
  };
};

export const debitCardTransactionHistoryRequest = (payload) => {
  return {
    type: creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_REQUEST,
    payload,
  };
};

export const debitCardTransactionHistoryComplete = (payload) => {
  return {
    type: creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_COMPLETE,
    payload,
  };
};

export const debitCardTransactionHistoryError = (payload) => {
  return {
    type: creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_ERROR,
    payload,
  };
};
